import { useMutation, useQuery } from "@apollo/client";
import { ADD_HELP_REQUEST_MESSAGE_MUTATION, LIST_HELP_REQUEST_MESSAGES } from "../graphQl/SupportAPI";
import { MESSAGE_SENDER_ROLE } from "../../../constants/supportStatus";

// Pas de subscription côté API : polling pour voir arriver les réponses du demandeur.
const MESSAGES_POLL_INTERVAL = 30000;

export const useHelpRequestMessages = (helpRequestId) => {
  const { data, loading, error, refetch } = useQuery(LIST_HELP_REQUEST_MESSAGES, {
    variables: { helpRequestId },
    skip: !helpRequestId,
    fetchPolicy: "cache-and-network",
    pollInterval: MESSAGES_POLL_INTERVAL,
  });

  const [sendMutation, { loading: isSending }] = useMutation(ADD_HELP_REQUEST_MESSAGE_MUTATION, {
    refetchQueries: ["HelpRequestMessages"],
    awaitRefetchQueries: true,
  });

  const sendMessage = async (content) => {
    const res = await sendMutation({
      variables: { helpRequestId, messageInput: { senderRole: MESSAGE_SENDER_ROLE.SUPPORT_AGENT, content } },
    });
    return res.data?.MT_ADD_HELP_REQUEST_MESSAGE?.data;
  };

  return {
    messages: data?.QR_LIST_HELP_REQUEST_MESSAGE?.data?.content || [],
    loading,
    error,
    refetch,
    sendMessage,
    isSending,
  };
};
